module.exports = __webpack_public_path__ + "static/exhibitB-977e6111c2bec6b9648312672ba1addd.jpg";